import {
  UniFiCategoryId,
  UniFiChildCategorySlug,
} from "@ubnt/store.core/lib/constants/proStoreCategories/mapping/unifi";
import { SiteId } from "@ubnt/store.core/lib/contexts/MenuContext/mapping";
import image from "../../assets/wifi/outdoor/u6-mesh.png";
import type { Product } from "../../types";
import { wifiOutdoor } from "../product-list-groups/wifiOutdoor";
import { extendedRangeMode6Ghz, radio6Ghz, wifiMounting } from "../properties";
import { antennaType } from "../properties/antennaType";
import { connectedDevices } from "../properties/connectedDevices";
import { wifiCoverage } from "../properties/coverage";
import { externalAntennaSupport } from "../properties/externalAntennaSupport";
import { uplink } from "../properties/uplink";
import { wifiTechnology } from "../properties/wifiTechnology";

export const u6Mesh: Product = {
  id: "u6Mesh",
  productTitle: "U6 Mesh",
  techspecsPath: [SiteId.TechSpecs, `/unifi/${UniFiCategoryId.WiFi}/u6-mesh`],
  storePathParts: {
    productSlug: "u6-mesh",
    category: UniFiChildCategorySlug.WiFiOutdoor,
  },
  sku: "U6-Mesh",
  description: "u6Mesh.description",
  image: { src: image, width: 200, height: 160 },
  productListGroup: wifiOutdoor,
  propertyValues: [
    {
      propertyId: "dimensions",
      value: {
        type: "string",
        value: 'Ø48.5 x 159.5 mm\n(Ø1.9 x 6.3")',
      },
    },
    {
      propertyId: wifiTechnology.id,
      value: {
        type: "translation",
        value: "u6Mesh.wifiTechnology",
      },
    },
    {
      propertyId: radio6Ghz.id,
      value: { type: "boolean", value: false },
    },
    {
      propertyId: extendedRangeMode6Ghz.id,
      value: { type: "boolean", value: false },
    },
    {
      propertyId: antennaType.id,
      value: {
        type: "translation",
        value: "antennaType.omnidirectional",
      },
    },
    {
      propertyId: wifiCoverage.id,
      value: { type: "string", value: "140 m² (1,500 ft²)" },
    },
    {
      propertyId: connectedDevices.id,
      value: { type: "string", value: "300+" },
    },
    {
      propertyId: externalAntennaSupport.id,
      value: { type: "boolean", value: false },
    },
    {
      propertyId: "powerMethodPoe",
      value: { type: "string", value: "PoE" },
    },
    {
      propertyId: uplink.id,
      value: { type: "translation", value: "u6Mesh.uplink" },
    },
    {
      propertyId: wifiMounting.id,
      value: {
        type: "translation",
        value: "u6Mesh.mounting.1",
        asterisk: 1,
      },
    },
    // MUST HAVE FOR OVERVIEW SECTION
    {
      propertyId: "radios",
      value: { type: "boolean", value: false },
    },
    {
      propertyId: "rfFilteringTechnology",
      value: { type: "boolean", value: false },
    },
    {
      propertyId: "weatherproofing",
      value: { type: "string", value: "IPX5" },
    },
    {
      propertyId: "redundantRj45Port",
      value: { type: "boolean", value: false },
    },
  ],
  notes: ["u6mesh.notes.mounting"],
};
